import { render, staticRenderFns } from "./EditSubjectIcon.vue?vue&type=template&id=8f938010&"
import script from "./EditSubjectIcon.vue?vue&type=script&lang=ts&"
export * from "./EditSubjectIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports